(() => {
  if (window.__ladyCatalogFiltersBound) return;
  window.__ladyCatalogFiltersBound = true;

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

  const getCatalogCards = () => [...document.querySelectorAll('[data-catalog-card][data-catalog-category]')];
  const getCatalogGroups = () => [...document.querySelectorAll('[data-catalog-group-section]')];

  const setTextKeepingCount = (element, text) => {
    if (!element) return;
    const count = element.querySelector('span');
    element.textContent = text;
    if (count) element.append(' ', count);
  };

  const hydrateCatalogPresentation = async () => {
    const editorial = document.querySelector('[data-catalog-presentation]');
    const endpoint = editorial?.dataset.catalogPresentationEndpoint;
    if (!editorial || !endpoint) return;
    try {
      const response = await fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const payload = await response.json();
      const presentation = payload.presentation;
      if (!presentation) return;

      const title = editorial.querySelector('[data-catalog-presentation-title]');
      const description = editorial.querySelector('[data-catalog-presentation-description]');
      const assurance = editorial.querySelector('[data-catalog-presentation-assurance]');
      const search = editorial.querySelector('[data-catalog-presentation-search]');
      if (title && presentation.title) title.textContent = presentation.title;
      if (description && presentation.description) description.textContent = presentation.description;
      if (assurance && presentation.assuranceLabel) assurance.textContent = presentation.assuranceLabel;
      if (search && presentation.searchPlaceholder) search.placeholder = presentation.searchPlaceholder;

      const categories = presentation.categories || {};
      Object.entries(categories).forEach(([key, category]) => {
        const group = document.querySelector(`[data-catalog-presentation-category="${key}"]`);
        if (!group || !category) return;
        group.dataset.catalogPresentationOrder = String(category.sortOrder ?? 0);
        group.dataset.catalogPresentationDisabled = category.enabled === false ? 'true' : 'false';
        group.hidden = category.enabled === false;
        const eyebrow = group.querySelector(`[data-catalog-category-eyebrow="${key}"]`);
        const heading = group.querySelector(`[data-catalog-category-title="${key}"]`);
        const note = group.querySelector(`[data-catalog-category-note="${key}"]`);
        if (eyebrow && category.eyebrow) eyebrow.textContent = category.eyebrow;
        if (heading && category.title) heading.textContent = category.title;
        if (note && category.note) note.textContent = category.note;
        document.querySelectorAll(`[data-catalog-filter="${key}"]`).forEach((control) => setTextKeepingCount(control, category.label || control.textContent));
        document.querySelectorAll(`[data-catalog-category-label="${key}"]`).forEach((option) => { option.textContent = category.label || option.textContent; });
      });

      const groups = getCatalogGroups().sort((left, right) => Number(left.dataset.catalogPresentationOrder || 0) - Number(right.dataset.catalogPresentationOrder || 0));
      const parent = groups[0]?.parentElement;
      if (parent) groups.forEach((group) => parent.appendChild(group));

      const guidance = document.querySelector('[data-catalog-guidance]');
      if (guidance && presentation.guidance) {
        const config = presentation.guidance;
        const values = [['[data-catalog-guidance-eyebrow]', config.eyebrow], ['[data-catalog-guidance-title]', config.title], ['[data-catalog-guidance-description]', config.description], ['[data-catalog-guidance-primary]', config.primaryLabel], ['[data-catalog-guidance-secondary]', config.secondaryLabel]];
        values.forEach(([selector, value]) => { const target = guidance.querySelector(selector); if (target && value) target.textContent = value; });
      }
    } catch (_error) {
      // The Liquid theme values remain the safe fallback in previews/offline mode.
    }
  };

  const updateSearchStatus = (catalog, visibleCount, totalCount, query, category) => {
    const status = catalog.querySelector('[data-catalog-search-status]');
    if (!status) return;

    if (!totalCount) {
      status.textContent = 'No hay opciones disponibles.';
      return;
    }

    if (query || category !== 'all') {
      status.textContent = `${visibleCount} ${visibleCount === 1 ? 'opción encontrada' : 'opciones encontradas'}.`;
      return;
    }

    status.textContent = `${totalCount} ${totalCount === 1 ? 'opción disponible' : 'opciones disponibles'}.`;
  };

  const applyCatalogFilters = (catalog, { scroll = false } = {}) => {
    if (!catalog) return;

    const searchInput = catalog.querySelector('[data-catalog-search-input]');
    const categorySelect = catalog.querySelector('[data-catalog-category-select]');
    const query = normalize(searchInput?.value);
    const category = categorySelect?.value || 'all';
    const queryTokens = query ? query.split(/\s+/).filter(Boolean) : [];
    const cards = getCatalogCards();
    const groups = getCatalogGroups();
    let visibleCount = 0;

    cards.forEach((card) => {
      const cardCategory = card.dataset.catalogCategory || 'courses';
      const cardText = normalize(card.dataset.catalogSearchText || card.textContent);
      const matchesCategory = category === 'all' || cardCategory === category;
      const matchesQuery = queryTokens.length === 0 || queryTokens.every((token) => cardText.includes(token));
      const visible = matchesCategory && matchesQuery;

      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    groups.forEach((group) => {
      const groupCards = [...group.querySelectorAll('[data-catalog-card]')];
      group.hidden = groupCards.length === 0 || !groupCards.some((card) => !card.hidden);
    });

    const emptyState = document.querySelector('[data-catalog-empty-state]');
    emptyState?.toggleAttribute('hidden', cards.length === 0 || visibleCount > 0);
    updateSearchStatus(catalog, visibleCount, cards.length, query, category);

    if (scroll) {
      document.querySelector('#catalog-results')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const syncCatalogControls = () => {
    const availableGroups = new Set(getCatalogGroups().filter((group) => group.dataset.catalogPresentationDisabled !== 'true').map((group) => group.dataset.catalogGroupSection));
    const hasGroups = availableGroups.size > 0;

    document.querySelectorAll('.le-catalog-editorial').forEach((catalog) => {
      catalog.querySelector('.le-catalog-editorial__tabs')?.toggleAttribute('hidden', !hasGroups);
      catalog.querySelector('.le-catalog-editorial__filters')?.toggleAttribute('hidden', !hasGroups);
      catalog.querySelector('[data-catalog-category-control]')?.toggleAttribute('hidden', !hasGroups);

      catalog.querySelectorAll('[data-catalog-filter]').forEach((control) => {
        const filter = control.dataset.catalogFilter || 'all';
        control.toggleAttribute('hidden', !hasGroups || (filter !== 'all' && !availableGroups.has(filter)));
      });

      const categorySelect = catalog.querySelector('[data-catalog-category-select]');
      categorySelect?.querySelectorAll('option[data-catalog-filter-option]').forEach((option) => {
        const filter = option.value || 'all';
        option.toggleAttribute('hidden', filter !== 'all' && !availableGroups.has(filter));
      });

      if (categorySelect && categorySelect.value !== 'all' && !availableGroups.has(categorySelect.value)) {
        categorySelect.value = 'all';
      }

      const activeControl = catalog.querySelector('[data-catalog-filter].is-active:not([hidden])');
      if (!activeControl && hasGroups) {
        catalog.querySelectorAll('[data-catalog-filter="all"]').forEach((control) => {
          control.classList.add('is-active');
          control.setAttribute('aria-current', 'page');
        });
      }

      applyCatalogFilters(catalog);
    });
  };

  syncCatalogControls();
  void hydrateCatalogPresentation().then(syncCatalogControls);
  document.addEventListener('shopify:section:load', syncCatalogControls);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-catalog-search-form]');
    if (!form) return;

    event.preventDefault();
    applyCatalogFilters(form.closest('.le-catalog-editorial'), { scroll: true });
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-catalog-search-input]');
    if (!input) return;

    applyCatalogFilters(input.closest('.le-catalog-editorial'));
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-catalog-category-select]');
    if (!select) return;

    const catalog = select.closest('.le-catalog-editorial');
    catalog?.querySelectorAll('[data-catalog-filter]').forEach((control) => {
      const isSelected = control.dataset.catalogFilter === select.value;
      control.classList.toggle('is-active', isSelected);
      if (isSelected) control.setAttribute('aria-current', 'page');
      else control.removeAttribute('aria-current');
    });
    applyCatalogFilters(catalog, { scroll: true });
  });

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-catalog-filter]');
    if (!control) return;

    const catalog = control.closest('.le-catalog-editorial');
    if (!catalog) return;

    event.preventDefault();
    const filter = control.dataset.catalogFilter || 'all';
    catalog.querySelectorAll('[data-catalog-filter]').forEach((item) => {
      const isSelected = item.dataset.catalogFilter === filter;
      item.classList.toggle('is-active', isSelected);
      if (isSelected) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });

    const categorySelect = catalog.querySelector('[data-catalog-category-select]');
    if (categorySelect) categorySelect.value = filter;
    applyCatalogFilters(catalog, { scroll: true });
  });
})();
